<template>
  <div :style="{fontSize: fSize + 'px'}">
    <slot></slot>
  </div>
</template>

<script>
  import Helpers from '@/tools/Helpers.js';
  let defaultWidth = 1280,
    defaultWidthMobile = 640,
    defaultFont = 16,
    minWidth = 320,
    minHeight = 320,
    defaultHeight = 720;

  export default {
    name: 'Resize',
    mounted() {
      this.bodyEl = document.querySelector('html');
      window.addEventListener('resize', this.onResize.bind(this));
      if (Helpers.isMobile() || Helpers.isIPAD()) {
        this.bodyEl.classList.add('mobile');
      } else {
        this.bodyEl.classList.remove('mobile');
      }
    },
    data() {
      return {
        vW: window.innerWidth,
        vH: window.innerHeight
      }
    },
    computed: {
      fSize() {
        if (Helpers.isMobile() || Helpers.isIPAD()) {
          return defaultFont * Math.max(minWidth, this.vW) / defaultWidthMobile;
        } else {
          return defaultFont * Math.min(Math.max(minWidth, this.vW) / defaultWidth, Math.max(minHeight, this.vH) / defaultHeight);
        }
      }
    },
    methods: {
      onResize() {
        this.vW = window.innerWidth;
        this.vH = window.innerHeight;
      }
    },
    components: {
      Helpers
    }

  }
</script>




// WEBPACK FOOTER //
// Resize.vue?63c38888